module.exports = __webpack_public_path__ + "img/cloverbakes-icons.fe189a06.svg";